import $http from "../axios";

const state = {
  transactions: []
};

const getters = {
  transactions: state => {
    return state.transactions;
  },
  transactionsReverse: state => {
    return JSON.parse(JSON.stringify(state.transactions.reverse()));
  }
};

const actions = {
  getTransactions({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(
          `transactions?storeId=${data.storeId}&beginDate=${
            data.dates[0]
          }&endDate=${data.dates[1]}`
        )
        .then(res => {
          if (res.data.result === "ok") {
            console.log("Transactions: ", res.data.payload);
            commit("SET_TRANSACTIONS", res.data.payload);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  changeOrderStatus(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`change-order-status`, data)
        .then(res => {
          if (res.data.result === "ok") {
            const index = state.transactions.findIndex(
              transaction => transaction._id === data._id
            );

            if (index !== -1) {
              state.transactions[index].orderLifecycle.status = data.status;
            }
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  // A tabela mostra o status "otimista" durante o polling localmente (ver
  // CancelTransactionModal.vue) e só recarrega as transações (get-transactions) quando o
  // cancelamento termina, pra evitar mexer no shape do objeto transação guardado na store.
  cancelTransaction(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`transactions/cancel`, data)
        .then(res => resolve(res))
        .catch(e => reject(e));
    });
  },

  getTransactionCancelStatus(_, transactionId) {
    return new Promise((resolve, reject) => {
      $http
        .get(`transactions/${transactionId}/cancel-status`)
        .then(res => resolve(res))
        .catch(e => reject(e));
    });
  },

  // Transação TEF em "Validar" (toValidate) que o franqueado confirmou como paga
  markTefTransactionPaid(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`mark-tef-transaction-paid`, data)
        .then(res => resolve(res))
        .catch(e => reject(e));
    });
  }
};

const mutations = {
  SET_TRANSACTIONS(state, payload) {
    state.transactions = payload.transactions;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
